<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import StatementGenerator from "@core/components/common/expression-language/StatementGenerator.vue";

export default {
    components: {StatementGenerator, AppCollapse, AppCollapseItem},
    name: 'ModuleFunction',
    props: {
        module: {
            required: true,
        },
        func: {
            required: true
        },
        nestedStatement: {
            default: false
        }
    },
    methods: {
        generateNestedName(func) {
            let args = func.arguments.map(arg => {
                return arg.name;
            });

            return this.generateNestedStatement(func) + '(' + args.join(', ') + ')';
        },
        generateNestedStatement(func) {
            return this.name + '.' + func.name;
        },
        argumentGeneratorComponent(arg) {
            if (!arg.definitions || arg.definitions.length === 0) {
                return false;
            }

            return arg.definitions.find(a => a.type === 'js');
        }
    },
    computed: {
        name() {
            let args = this.func.arguments.map(arg => {
                return arg.name;
            });

            return this.functionDefinition + '(' + args.join(', ') + ')';
        },
        functionDefinition() {
            if (this.nestedStatement) {
                return this.nestedStatement
            }
            return this.module.key + '.' + this.func.name;
        }
    }
}
</script>

<template>
    <div>
        <div v-if="func.arguments && func.arguments.length > 0" class="pb-1">
            <h5>Arguments</h5>

            <div v-for="arg in func.arguments" class="d-flex justify-content-between">
                <div>
                    <strong>{{ arg.name }}&lt;{{ arg.type }}&gt;</strong> - {{ arg.description }}
                </div>

                <StatementGenerator
                    v-if="argumentGeneratorComponent(arg)"
                    :statement="functionDefinition"
                    :argument="arg"
                    :func="func"
                    :arguments="func.arguments"
                    :component="argumentGeneratorComponent(arg)"
                />
            </div>
        </div>

        <h5>Examples</h5>

        <div v-for="example in func.usage">
            {{ module.key }}{{ example }}
        </div>
        <br>
        <div v-if="undefined === func.return.functions">
            Return: <strong>{{ func.return.type }}</strong>
        </div>
        <div v-else>
            <h5>Generates following chains</h5>
            <AppCollapse type="margin" accordion>
                <AppCollapseItem title="DS" v-for="f in func.return.functions">
                    <template #header>
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div><strong>{{ generateNestedName(f) }}</strong></div>
                            <div>{{ f.description }}</div>
                        </div>
                    </template>

                    <ModuleFunction
                        :module="func"
                        :func="f"
                        :nested="true"
                        :nestedStatement="generateNestedStatement(f)"
                    />
                </AppCollapseItem>
            </AppCollapse>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
